// Where one entity gives a shared column a different meaning. Re-exported from
// changeHistoryDictionary.ts; the shared names are in columnLabels.ts.

// The purchase a payment row is about, written into the row as a type and an id.
const PURCHASE_OWNER = { EntityName: "Lloji i blerjes", EntityId: "Blerja" };

export const ENTITY_COLUMN_LABELS: Record<string, Record<string, string>> = {
  Schedule: { Duration: "Minuta nga nisja", Description: "Shënimi i ndalesës" },
  Trip: { Duration: "Kohëzgjatja e udhëtimit (minuta)" },
  OperatorEntityCommisionFee: { EntityId: "Orari" },
  PaymentAttempt: { ...PURCHASE_OWNER, CreatedAtUtc: "Filloi më" },
  PaymentDispute: {
    ...PURCHASE_OWNER,
    AmountCents: "Shuma e kontestuar (në cent)",
    Reason: "Arsyeja e bankës",
    ProcessorStatus: "Statusi te Stripe"
  },
  PaymentProcessorRefund: { ...PURCHASE_OWNER, CreatedAtUtc: "Krijuar te procesori i kartelës më" },
  Refund: PURCHASE_OWNER,
  CreditReservationMapping: { ...PURCHASE_OWNER, ExpiresAtUtc: "Lirohet më" },
  WalletCredit: { EntityName: "Lidhur me", EntityId: "Nr. i lidhur" }
};
